export enum BankAccountDetailsStatus {
    current = 'current',
    old = 'old',
    processed = 'processed',
    requested = 'requested',
}
